BaseForm = App.loadClass "grower::viewmodels/prescription_map/Form"

class exports.Form extends BaseForm

    setInitialDeps: () ->
        super()
        @syncDeps(
            "Layer": 'grower::viewmodels/prescription_map/export/Layer'
        )


    constructor: (args...) ->
        super(args...)

        @setInitialDeps()



    recalcPopulations: () ->
        @layer().was_recalculated true

        old_keep = $.merge [], @layer()._keep_properties

        $.merge @layer()._keep_properties, [
            'hybrid_id'
            'target_population'
            'min_population'
            'max_population'
            'num_populations'
            'min_pop_diff'
            'max_pop_diff'
            'fields_id'
            'machinery_id'
        ]


        obj = @layer().serialize()

        @layer()._keep_properties = old_keep

        msg = @handler.dialog.find('.message_writer')

        msg.message_writer('info', 'Recalculating...')

        $.post 'backend/grower/layers/prescription-map/recalc-populations',
            json: obj,
            (result) =>
                #console.log result
                if not result.data? or result.status.type is 'error'
                    # Handler should show message ritter
                    msg.message_writer('error', result.status.msg)
                    return null

                for s, p of result.data.soils
                    for stage in @layer().stages
                        if stage.musym is s
                            stage.population p

                if result.status.type is 'success'
                    msg.message_writer('success', result.status.msg)
                    msg.message_writer('hide')

                else
                    msg.message_writer('info', result.status.msg)
